export default __webpack_public_path__ + "static/media/instagramIcon.cf1a63ca.svg";